import { getContrastRatio, getLuminance } from '@mui/material/styles';

// Ink used on genuinely light brand colours (yellow, lime, pastels).
export const DARK_INK = '#0F172A';
export const LIGHT_INK = '#FFFFFF';

// Above this relative luminance a colour reads as "light" and keeps dark
// text. Mid-tone brand colours — blues like #3B82F6 (0.24), greens like
// #10B981 (0.36), amber #F59E0B (0.44) — sit below it and get white, which is
// how people expect a filled pill or button to look, even where strict WCAG
// math would tip them to black. Yellows (#EAB308 ≈ 0.50, #FACC15 ≈ 0.64)
// and lime stay on dark ink.
const LIGHT_LUMINANCE = 0.45;

/** Text colour for a filled chip / button / badge drawn on `bg`. */
export function readableTextOn(bg: string, dark: string = DARK_INK, light: string = LIGHT_INK): string {
  try {
    return getLuminance(bg) > LIGHT_LUMINANCE ? dark : light;
  } catch {
    return light;
  }
}

/**
 * `accent` if it stands out enough on `surface` (3:1, WCAG non-text), else
 * `fallback`. For active / selected marks drawn in a brand colour on a
 * surface the tenant can also recolour — e.g. a primary-coloured icon on a
 * sidebar painted in that same primary.
 */
export function accentOn(accent: string, surface: string, fallback: string, minRatio = 3): string {
  try {
    return getContrastRatio(accent, surface) >= minRatio ? accent : fallback;
  } catch {
    return fallback;
  }
}
